var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "series-list-item" },
    [
      _c(
        "div",
        {
          staticClass: "series-list-item__series-info clickable",
          class: { "series-list-item__series-info--active": _vm.isActive },
          on: {
            click: function($event) {
              return _vm.selectSeries()
            }
          }
        },
        [
          _c("div", {
            staticClass: "series-list-item__series-cover-img-thumb float-left",
            style: _vm.coverImageStyle
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "series-list-item__series-description float-left" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "series-list-item__series-title typography--body-2 typography--font-weight-500"
                },
                [_vm._v("\n        " + _vm._s(_vm.seriesTitle) + "\n      ")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isActive
          ? _c("div", { staticClass: "series-list-item__chapter-list" }, [
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "text-center mt-16 mb-8" },
                    [
                      _c("LoadingBounce"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "typography--body-2 typography--color-disabled"
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("common.loading")) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "pl-8 pr-8" },
                    _vm._l(_vm.chapters, function(chapter) {
                      return _c("ChapterListItem", {
                        key: chapter.id,
                        attrs: {
                          chapter: chapter,
                          "is-active": _vm.selectedChapterId === chapter.id
                        },
                        on: { "select-chapter": _vm.selectChapter }
                      })
                    }),
                    1
                  )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-046a21e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-046a21e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/publishers/components/SeriesListItem.vue
// module id = etAw
// module chunks = 1